// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSquare as RawLucideSquare } from "lucide-react";
export const LucideSquare = /* @__PURE__ */ createIcon(RawLucideSquare, "LucideSquare", 2);
